var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-table',{attrs:{"columns":_vm.columns,"rows":_vm.exportPresets},scopedSlots:_vm._u([{key:"timeframes",fn:function(ref){
var value = ref.value;
return [_c('ui-inline-list',{attrs:{"items":value,"comparator":_vm.timeframeComparator}})]}},{key:"actions",fn:function(ref){
var row = ref.row;
return [_c('ui-link',{on:{"click":function($event){return _vm.$emit('edit-click', row)}}},[_vm._v("Bearbeiten")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }